export default "__VITE_ASSET__E1oT5XVqd9fm5KE3Ey4O5A__ 64w, __VITE_ASSET__EOBvqV7QHO9ofF20TDGjNQ__ 128w, __VITE_ASSET__nP8vXbN00dgA0dcDrP5Aiw__ 256w";